/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityOperator } from './DatabaseFieldVisibilityOperator';
import {
    DatabaseFieldVisibilityOperatorFromJSON,
    DatabaseFieldVisibilityOperatorFromJSONTyped,
    DatabaseFieldVisibilityOperatorToJSON,
} from './DatabaseFieldVisibilityOperator';
import type { DatabaseVisibilitySource } from './DatabaseVisibilitySource';
import {
    DatabaseVisibilitySourceFromJSON,
    DatabaseVisibilitySourceFromJSONTyped,
    DatabaseVisibilitySourceToJSON,
} from './DatabaseVisibilitySource';

/**
 * rule to show/hide a field based on the value of another field
 * @export
 * @interface DatabaseFieldVisibilityRule
 */
export interface DatabaseFieldVisibilityRule {
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldVisibilityRule
     */
    id?: string;
    /**
     * 
     * @type {DatabaseVisibilitySource}
     * @memberof DatabaseFieldVisibilityRule
     */
    source?: DatabaseVisibilitySource;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldVisibilityRule
     */
    fieldId?: string;
    /**
     * 
     * @type {DatabaseFieldVisibilityOperator}
     * @memberof DatabaseFieldVisibilityRule
     */
    operator?: DatabaseFieldVisibilityOperator;
    /**
     * 
     * @type {object}
     * @memberof DatabaseFieldVisibilityRule
     */
    value?: object;
}

/**
 * Check if a given object implements the DatabaseFieldVisibilityRule interface.
 */
export function instanceOfDatabaseFieldVisibilityRule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFieldVisibilityRuleFromJSON(json: any): DatabaseFieldVisibilityRule {
    return DatabaseFieldVisibilityRuleFromJSONTyped(json, false);
}

export function DatabaseFieldVisibilityRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldVisibilityRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'source': !exists(json, 'source') ? undefined : DatabaseVisibilitySourceFromJSON(json['source']),
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'operator': !exists(json, 'operator') ? undefined : DatabaseFieldVisibilityOperatorFromJSON(json['operator']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function DatabaseFieldVisibilityRuleToJSON(value?: DatabaseFieldVisibilityRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'source': DatabaseVisibilitySourceToJSON(value.source),
        'fieldId': value.fieldId,
        'operator': DatabaseFieldVisibilityOperatorToJSON(value.operator),
        'value': value.value,
    };
}

